<template>
  <div>
    <el-dialog :visible.sync="addDeviceUserDialogVisible" @close="feedBack" title="修改设备ID" v-if="addDeviceUserDialogVisible">
      <div>
        <span>新设备ID:</span>
        <el-input style="width: 200px" v-model="newDevID"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="updateDevID">确定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
export default {
  name: 'AddDeviceUser',
  props: ['addDeviceUserDialogVisible', 'devID']   ,
  data(){
    return {
      newDevID:'',
      update:{
        "version": 1,
        "method": "alarmpoint.SetPointDevID",
        "params": {
          "alarmPointId": "",
	        "devID":""
        },
        "token": "#",
        "id": 0
  }

    }
  },
  methods:{
    updateDevID(){
      this.update.params.devID = this.newDevID;
      this.update.params.alarmPointId = sessionStorage.getItem('alarmPointId');
      this.$axios.post(this.$mainUrl, this.update).then(res=>{
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type: 'success',
            message: '修改设备ID成功'
          })
          this.feedBack();
        }else{
          this.$message({
            type: 'error',
            message: '修改设备ID失败，' + res.data.error.message
          })
        }
      })
    },
    feedBack(){
      this.cleanArguments(this.update.params);
      this.resetValidate(this.update.params);
      this.addDeviceUserDialogVisible = false;
      this.$emit('feedBack',this.addDeviceUserDialogVisible);
    },

  }
}
</script>

<style scoped>

</style>
